export function getMenu(state) {
  return state.menu;
}

export function getFooterMenu(state) {
  return state.footerMenu;
}
